import { css, CSSResult } from 'lit'
import {
  csColorBackground,
  csColorBorder,
  csColorFunctional,
  csColorText
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csFontBodyS } from 'elements/_shared/fonts.style.js'


export const cseChip = {
  backgroundColor: css`var(--cse-chip-background-color, ${csColorBackground.primary})`,
  backgroundColorHover: css`var(--cse-chip-background-color-hover, ${csColorBackground.primary})`,
  backgroundColorDisabled: css`var(--cse-chip-background-color-disabled, ${csColorBackground.primary})`,
  borderColor: css`var(--cse-chip-border-color, ${csColorBorder.light})`,
  borderColorHover: css`var(--cse-chip-border-color-hover, ${csColorFunctional.info})`,
  borderColorDisabled: css`var(--cse-chip-border-color-disabled, ${csColorBorder.light})`,
  borderRadius: css`var(--cse-chip-border-radius, ${csBorder.radiusSubtle})`,
  borderWidth: css`var(--cse-chip-border-width, ${csBorder.width})`,
  color: css`var(--cse-chip-color, ${csColorText.body})`,
  colorHover: css`var(--cse-chip-color-hover, ${csColorText.body})`,
  colorDisabled: css`var(--cse-chip-color-disabled, ${csColorText.muted})`,
  columnGap: css`var(--cse-chip-column-gap, ${csSpacing.spacing04})`,
  height: css`var(--cse-chip-height, 32px)`,
  paddingInline: css`var(--cse-chip-padding-x, ${csSpacing.spacing05})`,
  paddingBlock: css`var(--cse-chip-padding-y, ${csSpacing.spacing04})`,

  selectedBackgroundColor: css`var(--cse-chip-selected-background-color, ${csColorBackground.info})`,
  selectedBackgroundColorDisabled: css`var(--cse-chip-selected-background-color-disabled, ${csColorBackground.disabled})`,
  selectedBorderColor: css`var(--cse-chip-selected-border-color, ${csColorBackground.info})`,
  selectedBorderColorDisabled: css`var(--cse-chip-selected-border-color-disabled, ${csColorBackground.disabled})`,
  selectedColor: css`var(--cse-chip-selected-color, ${csColorFunctional.info})`,
}

export const style: CSSResult = css`
  .cse-chip {
    --cse-text-color: ${cseChip.color};
    align-items: center;
    background: ${cseChip.backgroundColor};
    border-style: solid;
    border-width: ${cseChip.borderWidth};
    border-color: ${cseChip.borderColor};
    border-radius: ${cseChip.borderRadius};
    column-gap: ${cseChip.columnGap};
    display: inline-flex;
    min-height: ${cseChip.height};
    padding-block: ${cseChip.paddingBlock};
    padding-inline: ${cseChip.paddingInline};
    user-select: none;
    white-space: nowrap;
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: background-color, border-color, color;

    --cse-icon-button-small-size: 21px;
  }

  .cse-chip.full-width {
    width: 100%;
  }

  .cse-chip:not(:disabled) {
    cursor: pointer;
  }

  .cse-chip:hover {
    background: ${cseChip.backgroundColorHover};
    border-color: ${cseChip.borderColorHover};
    color: ${cseChip.colorHover};
  }

  .cse-chip:disabled {
    background-color: ${cseChip.backgroundColorDisabled};
    border-color: ${cseChip.borderColorDisabled};
    color: ${cseChip.colorDisabled};
    pointer-events: none;
  }

  .cse-chip.selected {
    background: ${cseChip.selectedBackgroundColor};
    border-color: ${cseChip.selectedBorderColor};
    color: ${cseChip.selectedColor};
  }

  .cse-chip.selected:hover {
    background: ${cseChip.selectedBackgroundColor};
    border-color: ${cseChip.borderColorHover};
  }

  .cse-chip.selected:disabled {
    background: ${cseChip.selectedBackgroundColorDisabled};
    border-color: ${cseChip.selectedBorderColorDisabled};
    color: ${cseChip.colorDisabled};
  }

  .cse-chip.dismissable {
    --cse-chip-padding-x: ${csSpacing.spacing05} ${csSpacing.spacing04};
    --cse-icon-size: ${csFontBodyS.fontSize};
  }

  [icon-role="cse-chip.dropdown"] {
    color: ${cseChip.color};
  }

  :disabled [icon-role="cse-chip.dropdown"] {
    color: inherit;
  }
`
